import React, { Component } from 'react';
import { DateTimeInput } from 'semantic-ui-calendar-react';
import { Form } from 'semantic-ui-react';
import axios from 'axios';
import MediaQuery from 'react-responsive';

class Incident extends Component {
  render() {
    return (
      <ResponsiveContainer>

      </ResponsiveContainer>
    );
  }
}

const ResponsiveContainer = (props) => {
  const { children } = props

  return (
    <div>
      <MobileContainer>{children}</MobileContainer>
      <DesktopContainer>{children}</DesktopContainer>
    </div>
  )
}

class MobileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      incidentTypes: [],
      dateTime: formatDate(new Date()),
      errorMessage: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDateTimeChange = this.handleDateTimeChange.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState({
      [name]: value
    });
  }

  handleDateTimeChange = (event, { value }) => {
    this.setState({ dateTime: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    require('formdata-polyfill');
    const data = new FormData(event.target);

    var jsonData = stringifyFormData(data, this.state.incidentTypes);
    /*
        fetch('http://localhost:52247/api/incidents', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: jsonData
        })
    */
    axios.post('http://localhost:52247/api/incidents', jsonData, {
      //axios.post('https://remo-dev.ualberta.ca/remoapis/api/incidents', jsonData, {      
      headers: { 'content-type': 'application/json' },
    })
      .then((response) => {
        this.setState({ errorMessage: response.data });
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          this.setState({ errorMessage: error.response.status + ": " + error.response.data });
        }
        else if (error.request) {
          this.setState({ errorMessage: "The server is not responding." });
        }
        else {
          this.setState({ errorMessage: "Something happened in setting up the request that triggered an Error" });
        }

      });

  }

  toggleCheckbox(event) {
    const target = event.target;
    const oid = target.attributes.oid.value;

    if (this.state.incidentTypes.indexOf(oid) > 0) {
      this.state.incidentTypes.splice(this.state.incidentTypes.indexOf(oid), 1);
    } else {
      this.state.incidentTypes.push(oid);
    }
  }

  render() {
    return (
      //<MediaQuery maxDeviceWidth={767}>
      <MediaQuery maxDeviceWidth={1}>
        <div>
          <form onSubmit={this.handleSubmit}>

            <input type="text" placeholder="ccid" name="CCID" onChange={this.handleChange} /><br />

            <DateTimeInput
              placeholder="Incident Time"
              name="IncidentTime"
              className="example-calendar-input"
              value={this.state.dateTime}
              onChange={this.handleDateTimeChange} /> <br />

            <label>
              Role of Incident:
            <select name="RoleOfIncident" value={this.state.roleOfIncident} onChange={this.handleChange}>
                <option value="Affected Party">Affected Party</option>
                <option value="Supervisor">Supervisor</option>
                <option value="Witness">Witness</option>
                <option value="Other">Other</option>
              </select>
            </label>    <br />

            <Form.Group grouped>
              <label> Incident Type:</label> <br />
              <Form.Field
                label="Environmental Release"
                name="IncidentTypes1"
                oid="ID00000001"
                control="input"
                type="checkbox"
                checked={this.state.EnvironmentalRelease}
                onChange={this.toggleCheckbox} />
              <Form.Field
                label="Exposure to Hazardous Substance"
                name="IncidentTypes2"
                oid="ID00000002"
                control="input"
                type="checkbox"
                checked={this.state.HazardousSubstance}
                onChange={this.toggleCheckbox} />
              <Form.Field
                label="Injury/Illness (Including sprains and strains)"
                name="IncidentTypes3"
                oid="ID00000003"
                control="input"
                type="checkbox"
                checked={this.state.Injury}
                onChange={this.toggleCheckbox} />
              <Form.Field
                label="Property Damage"
                name="IncidentTypes4"
                oid="ID00000004"
                control="input"
                type="checkbox"
                checked={this.state.Property}
                onChange={this.toggleCheckbox} />
              <Form.Field
                label="Other"
                name="IncidentTypes5"
                oid="ID00000005"
                control="input"
                type="checkbox"
                checked={this.state.Other}
                onChange={this.toggleCheckbox} />
            </Form.Group>         <br />

            <input name="IncidentTypeOther" type="text" placeholder="Incident Type Other" onChange={this.handleInputChange} /><br />

            <textarea name="Desc" placeholder="Incident Description" alue={this.state.desc} onChange={this.handleChange} />   <br />


            <br /><input type="submit" value="Submit" />
          </form>

          <ErrorHandling errorMessage={this.state.errorMessage} />
        </div>
      </MediaQuery>
    )
  }
}

class DesktopContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children } = this.props;
    return (
      //<MediaQuery minDeviceWidth={768}>
      <MediaQuery minDeviceWidth={2}>
        {(matches) => {
          if (matches) {
            var hostName = window.location.hostname;
            if(hostName === "localhost"){
              window.location.replace("https://remo-dev.ualberta.ca/REMO_DEV/ResourceAdministration/Project/ProjectEditor?ProjectType=_Incident&ProjectCreatorView=com.webridge.entity.Entity[OID[E0F4FFD98838414DB566CBA297243F85]]&ThisContainer=com.webridge.entity.Entity[OID[39F69A421BD03046AE43719893A2B607]]&Caller=ProjectCreator"); 
            }
            else{
              var href = window.location.href;              
              var startPos = href.indexOf("ualberta.ca");

              if(startPos>0)  {
                var siteName = href.substring(0, startPos-1);

                if(siteName.indexOf("//")>0){
                  siteName = siteName.substring(siteName.indexOf("//")+2);
                  if(siteName.indexOf("-")>0){
                    siteName = siteName.replace("-", "_");
                  }
                }
                href = href.substring(0, href.indexOf("/", 10) + 1) + siteName + "/";  
               
                if(siteName.indexOf("dev")>0 || siteName.indexOf("DEV")>0){                  
                  href += "ResourceAdministration/Project/ProjectEditor?ProjectType=_Incident&ProjectCreatorView=com.webridge.entity.Entity[OID[E0F4FFD98838414DB566CBA297243F85]]&ThisContainer=com.webridge.entity.Entity[OID[39F69A421BD03046AE43719893A2B607]]&Caller=ProjectCreator";
                }
                else{
                  href += "ResourceAdministration/Project/ProjectEditor?ProjectType=_Incident&ProjectCreatorView=com.webridge.entity.Entity[OID[E0F4FFD98838414DB566CBA297243F85]]&ThisContainer=com.webridge.entity.Entity[OID[4A4E60F3F6747B458E3C5DF8DB6AEED6]]&Caller=ProjectCreator";
                }
                window.location.replace(href);
              }
              else{
                return <div>Can't located incident creation url. Please contact administrator.</div>;              
              }
            }
            return null;
          }
          else{
            return null;
          }
        }}
      </MediaQuery>
    );
  }
}

class ErrorHandling extends Component {
  render() {
    return (
      <h1>{this.props.errorMessage}</h1>
    );
  }

}

function stringifyFormData(fd, incidentTypes) {
  const data = {};
  for (let key of fd.keys()) {
    if (key.indexOf("IncidentTypes") !== 0) {
      data[key] = fd.get(key);
    }
  }

  data["IncidentTypes"] = incidentTypes;
  return JSON.stringify(data);
}

function formatDate(date) {
  var day = date.getDate();
  var monthIndex = date.getMonth() + 1;
  var year = date.getFullYear();

  return monthIndex + '/' + day + '/ ' + year + " " + formatAMPM(date);
}


function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}



export default Incident;



// WEBPACK FOOTER //
// ./src/Incident.js